import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Iconify from '../iconify';

/**
 * Dialog component to handle unsaved changes
 * @param {boolean} open - Whether the dialog is open
 * @param {Function} onClose - Function to stay on the current page
 * @param {Function} onDiscard - Function to discard changes and leave
 * @param {string} title - Dialog title
 * @param {string} message - Dialog message
 * @param {boolean} isSaving - Whether save operation is in progress (for consistency)
 */
export default function UnsavedChangesDialog({
  open,
  onClose,
  onDiscard,
  title = "Unsaved Changes",
  message = "You have unsaved changes. What would you like to do?",
  isSaving = false
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
        }
      }}
    >
      <DialogTitle sx={{ pb: 2 }}>
        <Box display="flex" alignItems="center" gap={1}>
          <Iconify icon="eva:alert-triangle-outline" width={24} height={24} />
          {title}
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 3, pt: 0 }}>
        <Button
          variant="outlined"
          color="inherit"
          onClick={onClose}
          disabled={isSaving}
        >
          Stay Here
        </Button>
        
        <Button
          variant="outlined"
          color="error"
          onClick={onDiscard}
          disabled={isSaving}
          startIcon={<Iconify icon="eva:trash-2-outline" />}
        >
          Leave & Discard Changes
        </Button>
      </DialogActions>
    </Dialog>
  );
} 